import "./style.css";
import { useIntl } from "react-intl";
import {
  footerAppButtonStyle,
  footerDriverLinks,
  footerLegalLinks,
  footerLyftLinks,
  footerRiderLinks,
  footerSocialLinks,
  IconChevronDown,
} from "./shared";

const footerColumns = [
  { titleId: "footer.column.driver", links: footerDriverLinks },
  { titleId: "footer.column.rider", links: footerRiderLinks },
  { titleId: "footer.column.metuaa", links: footerLyftLinks },
];

function FooterColumn({ titleId, links, intl }) {
  const title = intl.formatMessage({ id: titleId });
  return (
    <div className="sc-dOvA-dm gASdYH">
      <div className="sc-eSfNbN gdATaP">
        <h2 data-testid="core-ui-text" className="sc-bmzYkS bmTkUk">
          {title}
        </h2>
      </div>
      <button type="button" className="sc-bXWnss dAzuYD core-ui-focus">
        <h2 data-testid="core-ui-text" className="sc-bmzYkS bmTkUk">
          {title}
        </h2>
        <span data-testid="core-ui-icon" className="sc-jEACwC fWFepk">
          <IconChevronDown />
        </span>
      </button>
      <ul className="sc-fLvQuD kmaTJn">
        {links.map((link) => (
          <li key={link.href} className="sc-cRmqLi fvtyuu">
            <a href={link.href} className="sc-dUWDJJ gtZVmu">
              <span data-testid="core-ui-text" className="sc-bmzYkS kfdjbm">
                {intl.formatMessage({ id: link.textId })}
              </span>
            </a>
          </li>
        ))}
      </ul>
      <div className="sc-aNeao eSwNsk">
        <div data-testid="core-ui-horizontal-divider" className="sc-iMWBiJ iTMXWV" />
      </div>
    </div>
  );
}

function SocialLinks({ className, intl }) {
  return (
    <ul className={className}>
      {footerSocialLinks.map(({ href, labelId, Icon }) => (
        <li key={href} className="sc-gwZKzw ggwNwt">
          <a href={href} className="sc-dAEZTx jKfBkx">
            <span
              data-testid="core-ui-icon"
              title={intl.formatMessage({ id: labelId })}
              aria-label={intl.formatMessage({ id: labelId })}
              className="sc-jEACwC fWFepk"
            >
              <Icon />
            </span>
          </a>
        </li>
      ))}
    </ul>
  );
}

export default function Footer() {
  const intl = useIntl();
  return (
    <footer className="sc-hyBbbR eUxAlv" style={{ zoom: 0.98 }}>
      <div data-testid="core-ui-layout-grid" className="sc-satoz eEJPJx">
        <div data-testid="core-ui-layout-container" className="sc-isRoRg efilsy" />
        <div data-testid="core-ui-layout-container" className="sc-isRoRg bGsZqN">
          <nav aria-label={intl.formatMessage({ id: "footer.ariaLabel" })}>
            <div className="sc-gIEZMH fdMzUh">
              {footerColumns.map((column) => (
                <FooterColumn key={column.titleId} titleId={column.titleId} links={column.links} intl={intl} />
              ))}

              <div className="sc-fKMpNL ibKFlj">
                <div className="sc-cQCQeq bHAXLB">
                  <span data-testid="core-ui-button-wrapper" className="sc-eBMEME NFYEc">
                    <a
                      data-testid="core-ui-button"
                      aria-disabled="false"
                      href="/app?type=driver"
                      style={footerAppButtonStyle}
                      className="sc-dCFHLb sc-tagGq gdHJGt krlRAc"
                    >
                      <span className="sc-gmPhUn kESbtj">
                        <span data-testid="multi-line-text-wrap" className="sc-aXZVg kGRXWn">
                          <span data-testid="icon-button-text" className="sc-bmzYkS cLfdwp">
                            {intl.formatMessage({ id: "footer.app.driver" })}
                          </span>
                        </span>
                      </span>
                    </a>
                  </span>
                  <div data-testid="core-ui-spacer" className="sc-gsFSXq JPSGo" />
                  <span data-testid="core-ui-button-wrapper" className="sc-eBMEME NFYEc">
                    <a
                      data-testid="core-ui-button"
                      data-tracking-category="riderWebOnboarding"
                      data-tracking-action="getRide"
                      data-tracking-label="footerRiderDownload"
                      aria-disabled="false"
                      href="https://lyft.sng.link/Adnq0/cig8?_dl=lyft%3A%2F%2F"
                      style={footerAppButtonStyle}
                      className="sc-dCFHLb sc-tagGq gdHJGt krlRAc"
                    >
                      <span className="sc-gmPhUn kESbtj">
                        <span data-testid="multi-line-text-wrap" className="sc-aXZVg kGRXWn">
                          <span data-testid="icon-button-text" className="sc-bmzYkS cLfdwp">
                            {intl.formatMessage({ id: "footer.app.rider" })}
                          </span>
                        </span>
                      </span>
                    </a>
                  </span>
                </div>
              </div>

            </div>

            <div data-testid="core-ui-spacer" className="sc-gsFSXq bNnPTB" />

            <div className="sc-inyXkq bWEueZ">
              <SocialLinks className="sc-fremEr JYesA" intl={intl} />
              <div data-testid="core-ui-spacer" className="sc-gsFSXq hoWflf" />

              <ul className="sc-fremEr YqhzH">
                {footerLegalLinks.map(({ href, textId, Icon }) => (
                  <li key={href} className="sc-gwZKzw ggwNwt">
                    <span data-testid="core-ui-text" className="sc-bmzYkS gEwtHY">
                      <a href={href} className="sc-etVdmn igZzmq">
                        {intl.formatMessage({ id: textId })}
                        {Icon ? (
                          <>
                            <div data-testid="core-ui-spacer" className="sc-gsFSXq dcMFhw" />
                            <Icon />
                          </>
                        ) : null}
                      </a>
                    </span>
                  </li>
                ))}
                <li className="sc-gwZKzw ggwNwt">
                  <span data-testid="core-ui-text" className="sc-bmzYkS gEwtHY">
                    © Metua'a, Inc., 2026.
                  </span>
                </li>
                <li className="sc-gwZKzw ggwNwt">
                  <span data-testid="core-ui-text" className="sc-bmzYkS gEwtHY">
                    CPUC ID No. TCP0032513-P
                  </span>
                </li>
              </ul>

              <SocialLinks className="sc-fremEr joIMpp" intl={intl} />
            </div>
          </nav>
        </div>
      </div>
    </footer>
  );
}